import React from "react";

interface AboutUsComponentProps {}

export const AboutUsComponent: React.FC<AboutUsComponentProps> = (
  props: AboutUsComponentProps
) => {
  return (
    <div className="py-16 text-center">
      <h1 className="text-gray-600">About us page coming soon</h1>
    </div>
  );
};
